import React, { useState, useEffect } from "react";
import {
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import MDButton from "components/MDButton";
import MDDialog from "components/MDDialog";
import { useMaterialUIController } from "context";

const CreateOmnipark = ({
  dialogOpen,
  onClose,
  omniparkData,
  isEditOmnipark,
  onSubmit,
}) => {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const [locationId, setLocationId] = useState("");

  useEffect(() => {
    if (isEditOmnipark) {
      setLocationId(omniparkData?.locationId || "");
    } else {
      setLocationId("");
    }
  }, [isEditOmnipark, omniparkData]);

  return (
    <MDDialog
      dialogTitle={isEditOmnipark ? "Edit Omnipark" : "Enable Omnipark"}
      open={dialogOpen}
      dialogClose={onClose}
      closeIcon={true}
      maxWidth="sm"
      fullWidth
    >
      <DialogContent>
        <TextField
          fullWidth
          label="Location ID"
          value={locationId}
          onChange={(e) => setLocationId(e.target.value)}
          margin="dense"
        />
      </DialogContent>

      <DialogActions>
        <MDButton variant="outlined" color="dark" onClick={onClose}>
          Cancel
        </MDButton>
        <MDButton
          variant="contained"
          color={sidenavColor}
          type="submit"
          onClick={() => {
            if (!locationId) return;
            onSubmit(locationId);
          }}
        >
          {isEditOmnipark ? "Save" : "Enable"}
        </MDButton>
      </DialogActions>
    </MDDialog>
  );
};

export default CreateOmnipark;
